import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customItems = null }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeMap = {
    '/order-management-dashboard': { label: 'Aufträge', icon: 'ClipboardList' },
    '/order-details': { label: 'Auftragsdetails', icon: 'FileText', parent: '/order-management-dashboard' },
    '/vin-scanner': { label: 'VIN Scanner', icon: 'Scan' },
    '/technician-assignment': { label: 'Techniker-Zuordnung', icon: 'Users' },
    '/technician-mobile-view': { label: 'Techniker Ansicht', icon: 'Smartphone', parent: '/technician-assignment' },
    '/revenue-analytics-dashboard': { label: 'Umsatz Analytics', icon: 'BarChart3' },
    '/dealership-management': { label: 'Autohaus-Verwaltung', icon: 'Building2' }
  };

  const generateBreadcrumbs = () => {
    if (customItems) {
      return customItems;
    }

    const currentRoute = routeMap?.[location?.pathname];
    if (!currentRoute) return [];

    const breadcrumbs = [];
    
    // Add home/dashboard
    breadcrumbs?.push({
      label: 'Dashboard',
      path: '/order-management-dashboard',
      icon: 'Home'
    });

    // Add parent if exists
    if (currentRoute?.parent && currentRoute?.parent !== '/order-management-dashboard') {
      const parentRoute = routeMap?.[currentRoute?.parent];
      if (parentRoute) {
        breadcrumbs?.push({
          label: parentRoute?.label,
          path: currentRoute?.parent,
          icon: parentRoute?.icon
        });
      }
    }

    // Add current page (not clickable)
    if (location?.pathname !== '/order-management-dashboard') {
      breadcrumbs?.push({
        label: currentRoute?.label,
        path: location?.pathname,
        icon: currentRoute?.icon,
        current: true
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-text-secondary mb-6" aria-label="Breadcrumb">
      {breadcrumbs?.map((item, index) => (
        <div key={item?.path} className="flex items-center">
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="mx-2 text-border" />
          )}
          
          {item?.current ? (
            <div className="flex items-center text-text-primary font-medium">
              <Icon name={item?.icon} size={14} className="mr-1.5" />
              {item?.label}
            </div>
          ) : (
            <button
              onClick={() => handleNavigation(item?.path)}
              className="flex items-center hover:text-primary transition-colors duration-150"
            >
              <Icon name={item?.icon} size={14} className="mr-1.5" />
              {item?.label}
            </button>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumb;